import { logger } from "src/app/modules/logging/logger.reference";
import { AuthActions, AuthActionTypes } from "./auth.actions";

export const authFeatureKey = "auth";

export interface AuthState {
  guardedRoute: string;
}

export const initialAuthState: AuthState = { guardedRoute: null };

export function authReducer(
  state = initialAuthState,
  action: AuthActions,
): AuthState {
  switch (action.type) {
    case AuthActionTypes.SetAuthState:
      logger.debug(`STORE: ${authFeatureKey} set to`, action.state);
      return action.state;

    case AuthActionTypes.SetGuardedRoute:
      const route = action.url;
      logger.debug(`STORE: ${authFeatureKey}.guardedRoute set to`, route);
      return Object.assign({}, state, { guardedRoute: route });

    default:
      return state;
  }
}
